import Close from "./sheet-close.svelte"
import Content from "./sheet-content.svelte"
import Description from "./sheet-description.svelte"
import Footer from "./sheet-footer.svelte"
import Header from "./sheet-header.svelte"
import Overlay from "./sheet-overlay.svelte"
import Portal from "./sheet-portal.svelte"
import Title from "./sheet-title.svelte"
import Trigger from "./sheet-trigger.svelte"
import Root from "./sheet.svelte"

export {
  Root,
  Close,
  Trigger,
  Portal,
  Overlay,
  Content,
  Header,
  Footer,
  Title,
  Description,
  //
  Root as Sheet,
  Close as SheetClose,
  Trigger as SheetTrigger,
  Portal as SheetPortal,
  Overlay as SheetOverlay,
  Content as SheetContent,
  Header as SheetHeader,
  Footer as SheetFooter,
  Title as SheetTitle,
  Description as SheetDescription,
}
